import { history } from './history'
const toPath = (path) => {
  if (/\/home28/.test(path)) {
    window.location.href = path
  } else {
    history.push(path)
  }
}

export { toPath }